import { DateTime } from 'luxon'
import { datetime } from '../serialization'
import { BeWizrModel } from './BeWizrModel'
import { BeWizrUser } from './BeWizrUser'

export class BeWizrMeeting extends BeWizrModel {

  public title!: string

  public shortDescription!: string | null
  public descriptionHtml!:  string | null

  public occurrences!: BeWizrMeetingOccurrence[]

  public links!: {
    image: string | null
  }

  protected afterDeserialize() {
    this.occurrences = this.raw.occurrences.map(
      (it: any) => BeWizrMeetingOccurrence.deserialize(it),
    )
  }
}

export class BeWizrMeetingOccurrence extends BeWizrModel {

  public meetingId!:               string
  public meetingTitle!:            string
  public meetingShortDescription!: string | null

  public isEnrolled!:      boolean
  public isOnWaitingList!: boolean

  public links!: {
    image:             string | null
    enroll:            string | null
    cancel:            string | null
    externalEnrollUrl: string | null
  }

  public get title() {
    return this.meetingTitle
  }

  public get shortDescription() {
    return this.meetingShortDescription
  }

  @datetime()
  public startDate!: DateTime

  @datetime()
  public endDate!: DateTime

  public capacity!:   number | null
  public placesLeft!: number | null

  public isOnline!: boolean

  public location!: BeWizrLocation | null

  public facilitator!: BeWizrUser | null

  public get mayEnroll() {
    return this.links.enroll != null || this.links.externalEnrollUrl != null
  }

  public get mayCancel() {
    return this.links.cancel != null
  }

  protected afterDeserialize() {
    if (this.raw.facilitator == null) { return }
    this.facilitator = BeWizrUser.deserialize(this.raw.facilitator)
  }

}

export interface BeWizrLocation {

  title: string
  descriptionHtml: string

  addressLine:    string
  addressZip:     string
  addressCity:    string
  addressCountry: string

}